import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import React from 'react'
import { useSelector } from 'react-redux'

import { useLabel } from '../../../../hooks/useLabel'

// Select de "Como soube", controlado por fora. As opções vêm de knowWay.options
const KnowWaySelect = ({ value, onChange, required, error, helperText }) => {
  const knowWays = useSelector(state => state.knowWay.options)
  const label = useLabel()

  return (
    <TextField
      select
      key={`input-know-way-id-${value}`}
      value={value || ''}
      label={label('know_way', 'Como soube da Empresa?')}
      fullWidth
      required={required}
      error={error}
      helperText={helperText}
      onChange={e => onChange(e.target.value)}
    >
      {knowWays?.map(knowWay => (
        <MenuItem key={knowWay?.id} value={knowWay?.id}>
          {knowWay?.name}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default KnowWaySelect
